import { createSlice } from '@reduxjs/toolkit';
const InitialState = {
    mailTodo: false,
    signList: false,
    selectSignOnWrite: false,
    selectSignOnWaimao: false,
    signEditOnSetting: false,
    signEditOnWrite: false,
    signEditOnWaimao: false,
    paidGuide: false,
    hiding: {
        mailTodo: false,
        signList: false,
        selectSignOnWrite: false,
        selectSignOnWaimao: false,
        signEditOnSetting: false,
        signEditOnWrite: false,
        signEditOnWaimao: false,
        paidGuide: false,
    },
};
const niceModalSlice = createSlice({
    name: 'niceModalReducer',
    initialState: InitialState,
    reducers: {
        showModal: (state, action) => {
            const { modalId, args } = action.payload;
            state[modalId] = args || true;
            state.hiding[modalId] = false;
        },
        hideModal: (state, action) => {
            const { modalId, force } = action.payload;
            if (force) {
                state[modalId] = false;
                state.hiding[modalId] = false;
            }
            else {
                state.hiding[modalId] = true;
            }
        },
    },
});
export const { actions } = niceModalSlice;
export default niceModalSlice.reducer;
